import { AddCircleOutline } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";

import { ConversationFolderForm } from "../conversation-folder-form";

import { useDashboardSidebarStore } from "@/hooks";

export function ConversationFoldersCreateButton() {
  const {
    conversationSidebar,
    actions: { updateConversationSidebar },
  } = useDashboardSidebarStore();
  const [showCreate, setShowCreate] = useState(false);

  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle1" fontWeight="bold">
          Folders
        </Typography>
        <IconButton onClick={() => setShowCreate(true)}>
          <AddCircleOutline />
        </IconButton>
      </Stack>

      {showCreate && (
        <ConversationFolderForm
          onCancel={() => setShowCreate(false)}
          options={{
            onSuccess: (data) => {
              setShowCreate(false);
              updateConversationSidebar({
                folders: [...conversationSidebar.data.folders, { folder: data, conversations: [] }],
              });
            },
          }}
        />
      )}
    </Stack>
  );
}
